/* import __COLOCATED_TEMPLATE__ from './payout-account-card.hbs'; */
import { A } from '@ember/array';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { PAYOUT_ACCOUNT } from '../models/payout-account';
import { PAYOUT_METHOD } from '../models/payout-method';

const CLASS_NAME = 'SH-c-payout-account-card';

export default Component.extend({
  session: service(),
  currentUser: readOnly('session.currentUser'),

  tagName: '',
  CLASS_NAME,

  PAYOUT_ACCOUNT,

  /** @param {PayoutAccount|null} */
  payoutAccount: null,

  /** @param {Function} */
  onRemove: () => {},

  /** @param {Function} */
  onSelect: () => {},

  /** @param {Function} */
  onVerify: () => {},

  /** @param {Function} */
  onEdit: () => {},

  /** @param {Boolean} */
  disabled: false,

  /** @type {String} */
  _type: readOnly('payoutAccount.accountType'),

  /** @type {String} */
  _method: readOnly('payoutAccount.accountMethod'),

  /** @type {String} */
  _action: readOnly('payoutAccount.requiredAction'),

  /** @type {Ember.A<Object>} */
  _menuOptions: computed(
    'currentUser.isAdmin',
    'onEdit',
    'onSelect',
    'onRemove',
    'payoutAccount.{accountType,preferred}',
    'payoneerLink',
    function () {
      const payoutAccount = this.get('payoutAccount');
      const menuOptions = A([]);

      if (this.get('currentUser.isAdmin')) {
        menuOptions.pushObject({
          title: 'Edit',
          hasSeparatorAfter: true,
          onClick: () => this.get('onEdit')(payoutAccount),
        });
      }

      if (!payoutAccount.get('preferred') && payoutAccount.get('status') === PAYOUT_ACCOUNT.STATUSES.ACTIVE) {
        menuOptions.pushObject({
          title: 'Select',
          hasSeparatorAfter: true,
          onClick: () => this.get('onSelect')(payoutAccount),
        });
      }

      if (this.get('_type') === PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYONEER
        && this.get('_action') === PAYOUT_ACCOUNT.REQUIRED_ACTIONS.NONE
      ) {
        menuOptions.pushObject({
          title: 'Open on Payoneer site',
          hasSeparatorAfter: true,
          onClick: () => window.open(this.get('payoneerLink'), '_blank'),
        });
      }

      menuOptions.pushObject({
        title: 'Remove',
        class: 'lsg-red',
        onClick: () => this.get('onRemove')(payoutAccount),
      });

      return menuOptions;
    },
  ),

  /** @type {Boolean} */
  _hasAction: computed('payoutAccount.requiredAction', function () {
    return this.get('payoutAccount.requiredAction') !== PAYOUT_ACCOUNT.REQUIRED_ACTIONS.NONE;
  }),

  /** @type {Boolean} */
  _showActionButton: computed('currentUser.isAdmin', function () {
    return !this.get('currentUser.isAdmin');
  }),

  _showCurrency: computed(
    '_method',
    function() {
      const method = this.get('_method');

      return method == PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.BANK
        || method == PAYOUT_METHOD.HYPERWALLET_ACCOUNT_METHODS.WIRE;
    }
  ),

  /** @type {String} */
  payoneerLink: computed('payoutAccount.{loginLink,registrationLink}', function () {
    const payoutAccount = this.get('payoutAccount');
    return payoutAccount.get('loginLink') || payoutAccount.get('registrationLink');
  }),

  actions: {
    handleVerify() {
      this.get('onVerify')();
    },
  },
});
